module.exports = __webpack_public_path__ + "static/GTEestiProDispTrialLight-b81d4b768d0dcbb442b1f0941c22dc9f.woff";